import React from 'react';
import Button from './Button';
import ArrowLeftIcon from './icons/ArrowLeftIcon';
import { useTranslation } from 'react-i18next';

interface BackButtonProps {
  onClick: () => void;
  className?: string;
  title?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, className = '', title }) => {
  const { t } = useTranslation();
  const buttonTitle = title || t('backButton.title');

  return (
    <Button
      onClick={onClick}
      variant="ghost"
      className={`!p-2 text-slate-600 hover:text-sky-600 ${className}`}
      title={buttonTitle}
      aria-label={buttonTitle}
    >
      <ArrowLeftIcon className="w-5 h-5" strokeWidth={2} />
      <span className="ml-1.5 font-medium text-sm hidden sm:inline">{buttonTitle}</span>
    </Button>
  );
};

export default BackButton;